import IObjectSelectSearchPayload from '../entities/IObjectSelectSearchPayload';
import { createMutableAction } from '@bimser/core';
import { SELECT_POPOVER_SEARCH_ACTION } from './actionTypes';

const selectPopoverSearchAction = (payload: IObjectSelectSearchPayload) =>
	createMutableAction(SELECT_POPOVER_SEARCH_ACTION, payload);
export default selectPopoverSearchAction;
